"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKeys } from "@/constants/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";
import useSession from "@/hooks/QueryHooks/useSession";
import { getUserConversations } from "../actions";
export const USER_CONVERSATIONS_QUERY_KEYS = {
  all: [QueryKeys.CHAT_CONVERSATIONS],
  getUserConversations: (userId: string) => [...USER_CONVERSATIONS_QUERY_KEYS.all, "conversations-by-user", userId]
};
export function getUserConversationsQueryOptions({
  userId
}: {
  userId?: string;
} = {}) {
  return queryOptions({
    queryKey: USER_CONVERSATIONS_QUERY_KEYS.getUserConversations(userId),
    queryFn: () => getUserConversations({
      userId
    }),
    enabled: !!userId
  });
}
export const useUserConversations = () => {
  const $ = _c(2);
  const {
    data: session
  } = useSession();
  const t0 = session?.id;
  let t1;
  if ($[0] !== t0) {
    t1 = getUserConversationsQueryOptions({
      userId: t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useQuery(t1);
};